// extracted by mini-css-extract-plugin
module.exports = {"cartLink":"CartLink_cartLink__VhF_d","quantity":"CartLink_quantity__8mgwJ","cartLinkIcon":"CartLink_cartLinkIcon__pF5VH","cartLinkDesktop":"CartLink_cartLinkDesktop__yRwT6","cartLinkMobile":"CartLink_cartLinkMobile__HwPGK"};
module.exports.__checksum = "0c1dd1f50dd8"
